import type { Props } from './Svg'
import { Svg } from './Svg'

export function HeartPlusIcon(props: Props) {
  return (
    <Svg width="22" height="18" fill="none" stroke="none" {...props}>
      <path
        fill="currentColor"
        d="m10 18-3.175-2.85a92.776 92.776 0 0 1-3.087-2.9c-.859-.85-1.567-1.65-2.125-2.4C1.054 9.1.646 8.375.388 7.675A6.296 6.296 0 0 1 0 5.475c0-1.567.525-2.871 1.575-3.913C2.625.521 3.933 0 5.5 0c.867 0 1.692.183 2.475.55A5.93 5.93 0 0 1 10 2.1 5.93 5.93 0 0 1 12.025.55 5.769 5.769 0 0 1 14.5 0c1.35 0 2.483.379 3.4 1.137A5.69 5.69 0 0 1 19.775 4H17.65c-.3-.667-.742-1.167-1.325-1.5A3.628 3.628 0 0 0 14.5 2c-.85 0-1.583.23-2.2.688-.617.458-1.192 1.062-1.725 1.812h-1.15c-.517-.75-1.104-1.354-1.762-1.812A3.705 3.705 0 0 0 5.5 2c-.95 0-1.771.329-2.463.987C2.346 3.646 2 4.475 2 5.475c0 .55.117 1.108.35 1.675.233.567.65 1.221 1.25 1.963.6.741 1.417 1.608 2.45 2.599C7.083 12.704 8.4 13.9 10 15.3c.433-.383.942-.825 1.525-1.325s1.05-.917 1.4-1.25l.225.225.487.488.488.487.225.225c-.367.333-.833.746-1.4 1.237-.567.492-1.067.93-1.5 1.313L10 18Zm7-4v-3h-3V9h3V6h2v3h3v2h-3v3h-2Z"
      />
    </Svg>
  )
}
